import BulkActionsFooter from "./BulkActionsFooter";

export default BulkActionsFooter;